import { NavLink, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useState } from "react";
import { setLanguage } from "../../i18n/i18n";
import "./Navbar.css";

export default function Navbar() {
  const { t, i18n } = useTranslation("common");
  const location = useLocation();
  const [menuOpen, setMenuOpen] = useState(false);

  const isHome = location.pathname === "/";
  const visible = !isHome;
  const isRTL = i18n.language === "ar";

  const toggleLang = async () => {
    await setLanguage(i18n.language === "ar" ? "en" : "ar");
  };

  const toggleMenu = () => setMenuOpen(!menuOpen);

  if (!visible) return null;

  return (
    <>
      <header className={`nav ${visible ? "nav--show" : ""}`} dir={isRTL ? "rtl" : "ltr"}>
        <div className="nav__inner container">
          {/* Centered Logo Image */}
          <NavLink to="/" className="nav__brand" onClick={() => setMenuOpen(false)}>
            <img src="/brand/logo.png" alt="Terhal Logo" className="nav__logoImg" />
          </NavLink>

          {/* Menu Button (Positioned via CSS based on LTR/RTL) */}
          <button className={`nav__menuBtn ${menuOpen ? "nav__menuBtn--open" : ""}`} onClick={toggleMenu} aria-label={t("nav.toggleMenu")}>
            <span className="nav__hamburger"></span>
          </button>
        </div>
      </header>

      {/* Full-Screen Menu Overlay */}
      <div className={`nav__menuOverlay ${menuOpen ? "nav__menuOverlay--open" : ""}`} dir={isRTL ? "rtl" : "ltr"}>
        <div className="nav__menuContent">
          {/* Close Button */}
          <button className="nav__closeBtn" onClick={toggleMenu} aria-label={t("nav.closeMenu")}>
            ✕
          </button>

          {/* Menu Links with Trees */}
          <nav className="nav__menuLinks">
            <NavLink to="/" onClick={toggleMenu}>{t("nav.home") || "Home"}</NavLink>
            <NavLink to="/about" onClick={toggleMenu}>{t("nav.about")}</NavLink>
            <NavLink to="/investments" onClick={toggleMenu}>{t("nav.investments")}</NavLink>
            <NavLink to="/media-center" onClick={toggleMenu}>{t("nav.media")}</NavLink>

            {/* Governance Tree */}
            <div className="nav__tree">
              <span className="nav__treeToggle" onClick={(e) => e.currentTarget.nextElementSibling.classList.toggle("nav__menu--open")}>
                {t("nav.governance")} <span className="nav__arrow">▼</span>
              </span>
              <div className="nav__menu">
                <NavLink to="/governance/policies" onClick={toggleMenu}>{t("gov.policies")}</NavLink>
                <NavLink to="/governance/board-minutes" onClick={toggleMenu}>{t("gov.minutes")}</NavLink>
                <NavLink to="/governance/regulations" onClick={toggleMenu}>{t("gov.regulations")}</NavLink>
                <NavLink to="/governance/financial-statements" onClick={toggleMenu}>{t("gov.statements")}</NavLink>
                <NavLink to="/governance/annual-reports" onClick={toggleMenu}>{t("gov.annual")}</NavLink>
              </div>
            </div>

            {/* Management Tree */}
            <div className="nav__tree">
              <span className="nav__treeToggle" onClick={(e) => e.currentTarget.nextElementSibling.classList.toggle("nav__menu--open")}>
                {t("nav.management")} <span className="nav__arrow">▼</span>
              </span>
              <div className="nav__menu">
                <NavLink to="/management/board" onClick={toggleMenu}>{t("mgmt.board.t.board")}</NavLink>
                <NavLink to="/management/ceo" onClick={toggleMenu}>{t("mgmt.ceo")}</NavLink>
                <NavLink to="/management/org-structure" onClick={toggleMenu}>{t("mgmt.org")}</NavLink>
              </div>
            </div>

            <NavLink to="/contact" onClick={toggleMenu}>{t("nav.contact")}</NavLink>

            {/* Language Toggle */}
            <button className="nav__lang" onClick={toggleLang}>
              {i18n.language === "ar" ? t("nav.lang.en") : t("nav.lang.ar")}
            </button>
          </nav>

          {/* Social Media Links at Bottom */}
          <div className="nav__social">
            <a href="https://x.com/Tarhal_sa" target="_blank" rel="noreferrer">{t("nav.social.x")}</a>
            <a href="https://www.instagram.com/trhal.sa" target="_blank" rel="noreferrer">{t("nav.social.instagram")}</a>
            <a href="https://api.whatsapp.com/send/?phone=966535531261&text&type=phone_number&app_absent=0" target="_blank" rel="noreferrer">{t("nav.social.whatsapp")}</a>
          </div>
        </div>
      </div>
    </>
  );
}